var _defs, _g, _path, _path2, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBitmart = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 723 191",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u7F16\\u7EC4",
    "data-name": " \\u7F16\\u7EC4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-77",
    className: "cls-1",
    d: "M123.1,27.7c-10.3-8.5-24.4-12.7-42.4-12.7h-44.8v6.3h44c15.3,0,29.1,3.1,37.6,10.5s14.8,18.2,14.8,31.6-5.6,22.5-14.3,29.8-24.5,10.5-40.2,10.5H27.3v6.3h50.9c18.9,0,33.7-4.1,44.4-12.3,10.6-8.2,16-19.8,16-34.7s-5.2-26.9-15.5-35.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-79",
    className: "cls-1",
    d: "M119.3,36.7c-6.4-4.9-13.7-8.8-34.5-8.8h-34.6v6.1s15.5-.2,33.8,0c17.7.2,24.2,2.2,30.2,6.6,7.6,5.6,12.4,12.6,12.4,22.3s-4.8,16-12.5,21.7c-7.8,5.8-19.8,5.8-24.7,6h-25.7v6.1s11.8.2,19.2,0c16.8-.4,26.8-1.4,36.1-8.3,8.7-6.5,13.3-15,13.3-25.8s-7.2-21.3-13-25.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-80",
    className: "cls-1",
    d: "M116.2,44.8c-4.8-3-9-5-28.9-5h-24.9v4h24.2c17.6,0,24.2,3.1,26.3,4.4,4,2.4,9.2,6.4,9.2,14.4s-3,11.6-7.5,14.1c-4.1,2.3-11.6,4.4-24.7,4.4H8.7v4h81.4c15.9,0,21.3-1.8,26.9-4.9s9.4-9.5,9.4-17.6-5.1-14.6-10.2-17.8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill-81",
    className: "cls-1",
    d: "M132,89.1c-10.3-8.5-24.4-12.7-42.4-12.7h-30v6.3h29.1c15.3,0,29.1,3.2,37.6,10.5s14.9,18.2,14.9,31.6-5.5,22.5-14.3,29.8-24.5,10.5-40.2,10.5h-50.5v6.3h50.9c18.9,0,33.7-4.1,44.4-12.3s16-19.8,16-34.7-5.2-26.8-15.5-35.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-82",
    className: "cls-1",
    d: "M128.2,98.1c-6.4-4.8-13.7-8.8-34.5-8.8h-47v6.1s27.9-.2,46.2,0c17.7.2,24.2,2.2,30.2,6.6,7.6,5.6,12.4,12.6,12.4,22.3s-4.8,16-12.5,21.7c-7.8,5.8-19.8,5.8-24.7,6h-25.7v6.1s11.9.2,19.2,0c16.8-.4,26.8-1.4,36.1-8.3,8.7-6.5,13.3-15,13.3-25.8s-7.1-21.3-13-25.9"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-83",
    className: "cls-1",
    points: "56.7 118.9 100.8 118.9 100.8 115.5 56.7 115.5 56.7 118.9"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-84",
    className: "cls-1",
    points: "74.9 130.8 100.5 130.8 100.5 127.9 74.9 127.9 74.9 130.8"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-85",
    className: "cls-1",
    points: "36.2 118.9 49.2 118.9 49.2 115.5 36.2 115.5 36.2 118.9"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-86",
    className: "cls-1",
    points: "28 131 67.7 131 67.7 127.6 28 127.6 28 131"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-87",
    className: "cls-1",
    points: "37.8 43.5 53.3 43.5 53.3 40.7 37.8 40.7 37.8 43.5"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-88",
    className: "cls-1",
    points: "27.1 66.3 62.4 66.3 62.4 63.1 27.1 63.1 27.1 66.3"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-89",
    className: "cls-1",
    points: "28 157.7 65.3 157.7 65.3 153.7 28 153.7 28 157.7"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-90",
    className: "cls-1",
    points: "18.8 171 28.1 171 28.1 165.1 18.8 165.1 18.8 171"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-91",
    className: "cls-1",
    points: "42 56.3 100.6 56.3 100.6 53.1 42 53.1 42 56.3"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-92",
    className: "cls-1",
    points: "71.3 66.3 99.5 66.3 99.5 63.1 71.3 63.1 71.3 66.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-93",
    className: "cls-1",
    d: "M125.1,106.8c-4.8-2.9-9-4.9-28.9-4.9h-31.6v3.9h31c17.6,0,24.3,3,26.3,4.2,3.9,2.3,9.2,6.1,9.2,13.9s-3,11.2-7.5,13.6c-4.1,2.2-11.6,4.2-24.7,4.2H17.6v3.9h81.4c15.9,0,21.3-1.7,26.9-4.7s9.3-9.1,9.3-17c.1-8.7-5-13.9-10.1-17.1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-94",
    className: "cls-1",
    d: "M208.5,98.1v35.7h19.5c8.4,0,15-1.6,19.6-4.8,4.5-2.9,7.1-7.9,7-13.3,0-11.7-9.9-17.6-29.6-17.6h-16.5ZM208.5,55.6v32h14.7c7.9,0,14-1.5,18.5-4.6,4.4-2.8,7-7.8,6.8-13,0-9.6-7.8-14.5-23.5-14.5h-16.5ZM194.1,144.3V45.1h34.9c10.6,0,19,2.1,25.2,6.3s9.3,9.7,9.3,16.4c.1,5.4-1.9,10.7-5.6,14.7-3.8,4.2-8.9,7.1-15.5,8.9v.3c8.3.8,14.9,3.3,19.8,7.6,4.9,4.1,7.6,10.2,7.4,16.6,0,8.5-3.8,15.3-11.3,20.6-7.5,5.3-17,7.9-28.5,7.9h-35.7,0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-95",
    className: "cls-1",
    d: "M285.6,144.3h14v-70.8h-14v70.8ZM292.7,55.4c-2.3.1-4.6-.7-6.4-2.1-1.7-1.2-2.7-3.2-2.6-5.2,0-2.1,1-4.1,2.6-5.3,1.8-1.4,4.1-2.2,6.4-2.1,2.4-.1,4.7.7,6.5,2.1,2.9,2.1,3.5,6.1,1.5,9-.4.6-.9,1.1-1.5,1.5-1.8,1.5-4.1,2.2-6.5,2.1h0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-96",
    className: "cls-1",
    d: "M361.5,143.6c-3.3,1.5-7.7,2.2-13.1,2.2-15.3,0-23-6.9-23-20.8v-41.9h-15v-9.7h15v-17.3l14-3.7v21h22v9.7h-22v39.9c0,4.7,1,8.1,3,10.2s5.3,3,9.9,3c3.2.1,6.4-.7,9.1-2.4v9.8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-97",
    className: "cls-1",
    d: "M488.8,144.3h-13.1v-61.2c0-5.9.4-11.9,1.1-17.8h-.3c-.8,3-2,6-3.4,8.8l-38.5,70.1h-6.5l-38.4-69.6c-1.5-3-2.6-6.1-3.4-9.4h-.3c.5,5.9.7,11.9.6,17.9v61.1h-12.7V53h17.5l34.6,63.6c2,3.5,3.8,7.2,5.2,11h.5c2.3-5,4.1-8.7,5.4-11.2l35.3-63.4h16.5v91.3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-98",
    className: "cls-1",
    d: "M560,108.4l-21.1,2.4c-6.5.7-11.4,2-14.7,3.9s-5,5.2-5,9.9,1.7,6.6,4.6,8.5c3,2.2,7.1,3.3,12.2,3.3s12.7-2,17.2-5.9c4.4-3.7,6.9-9.2,6.8-15v-7.1h0ZM574,144.3h-14v-11.1h-.3c-6.1,8.5-15.1,12.7-26.9,12.7s-15.5-1.9-20.5-5.6c-4.8-3.4-7.5-9-7.4-14.9,0-13.2,9.6-20.9,28.9-23.1l26.2-3c0-12-6-18-18-18-10.2-.1-20.1,2.9-28.5,8.7v-11.6c8.6-4.4,18.5-6.6,29.7-6.6,20.6,0,30.8,8.8,30.8,26.4v46.1h0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-99",
    className: "cls-1",
    d: "M639,84.9c-2.5-1.5-6-2.3-10.6-2.3-5.8-.1-11.3,2.4-15,6.9-4,4.6-6,10.8-6,18.7v36.1h-14v-70.8h14v14.6h.3c1.8-4.7,5-8.8,9.2-11.7,4-2.8,8.8-4.2,13.8-4.2,2.8-.1,5.7.2,8.4,1v11.7"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-100",
    className: "cls-1",
    d: "M687.8,143.6c-3.3,1.5-7.7,2.2-13.1,2.2-15.3,0-23-6.9-23-20.8v-41.9h-15v-9.7h15v-17.3l14-3.7v21h22v9.7h-22v39.9c0,4.7,1,8.1,3,10.2s5.3,3,9.9,3c3.2.1,6.4-.7,9.1-2.4v9.8"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBitmart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Bitmart.b8296698a582bceae1b02ffea4cc71a0.svg";